import React from 'react';

import { fromAnyToMessageCharacterCount, fromAnyToMessageTextLength } from 'bl/messages/conversion.bl';
import Space from 'components/generic/Space.component';
import { useTranslation } from 'providers/GILT.provider';

const CharacterLimit = ({ value, limit }) => {
  const { t } = useTranslation();

  const length = fromAnyToMessageTextLength(value);
  const max = limit ?? fromAnyToMessageCharacterCount(value);

  return (
    <span data-bem="CharacterLimit">
      {limit ? t('composite.characterLimit.limit') : t('composite.characterLimit.character')}
      <Space>
        {length}/{max}
      </Space>
    </span>
  );
};

export default CharacterLimit;
